import React, { createContext, useContext } from 'react'
import { useTagManager } from '../hooks/use-tag-manager'

const TagManagerContext = createContext();

export const TagManagerProvider = ({ children }) => {
    const tagManager = useTagManager();
    return (
        <TagManagerContext.Provider value={tagManager}>
            {children}
        </TagManagerContext.Provider>
    )
}

export const useTagManagerContext = () => {
    return useContext(TagManagerContext);
}